<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-decoration__specialDecorationType">
      <div  style="width: 50px">
        <el-button
                size="small"
                type="primary"
                @click="addOrUpdateHandle()"
        >
          + 新增类别
        </el-button>
      </div>
      <el-tabs v-model="activeName" tab-position="left" @tab-click="handleClick" closable @tab-remove="removeTab">
        <el-tab-pane v-for="(type,index) in typeList"  :key="type.id" :label="type.typeName" :name="type.id">
          <el-form :inline="true" style="float: right" :model="dataForm">
            <el-form-item>
              <el-button v-if="$hasPermission('xytsz:specialDecorationType:save')" type="primary" @click="addHandle(type,index)">新增奖章</el-button>
            </el-form-item>
          </el-form>
          <el-table v-loading="dataListLoading" :data="medalList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
            <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
            <el-table-column prop="specialName" label="奖章名" header-align="center" align="center"></el-table-column>
            <el-table-column prop="imgUrl" label="图标" header-align="center" align="center">
              <template slot-scope="scope">
                <el-image  style="width: 100px; height: 100px" :src="scope.row.imgUrl" fit="cover"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="theme" label="主题" header-align="center" align="center"></el-table-column>
            <el-table-column prop="educationPoint" label="教育要点" header-align="center" align="center"></el-table-column>
            <el-table-column prop="decorationLevel" label="奖章层级" header-align="center" align="center"></el-table-column>
            <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
              <template slot-scope="scope">
                <el-button v-if="$hasPermission('xytsz:specialDecorationType:update')" type="text" size="small" @click="updateHandle(scope.row.id,index)">{{ $t('update') }}</el-button>
                <el-button v-if="$hasPermission('xytsz:specialDecorationType:delete')" type="text" size="small" @click="deleteById(scope.row.id)">{{ $t('delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <decoration-add-or-update v-if="addVisible" ref="decorationAddOrUpdate" @refreshDataList="getDecorationList"></decoration-add-or-update>
          <el-pagination
                  :current-page="page"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="limit"
                  :total="total"
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="pageSizeChangeHandle"
                  @current-change="pageCurrentChangeHandle">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getTypeList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './specialdecorationtype-add-or-update'
import DecorationAddOrUpdate from './specialdecoration-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/xytsz/specialDecorationType/page',
        getDataListIsPage: true,
        exportURL: '/xytsz/specialDecorationType/export',
        deleteURL: '/xytsz/specialDecorationType',
        deleteIsBatch: true
      },
      addVisible: false,
      activeName: '',
      typeList: [],
      medalList: [],
      dataForm: {
        typeId: '',
        typeName: ''
      }
    }
  },
  mounted () {
    this.getTypeList()
  },
  methods: {
    removeTab (tab) {
      this.$confirm(this.$t('prompt.info', { handle: this.$t('delete') }), '是否确认删除类别？', {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http.get('xytsz/specialDecorationType/deleteById/' + tab).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.getTypeList()
          this.$notify({
            type: 'info',
            duration: '750',
            message: '奖章删除成功'
          })
        })
      })
    },
    getDecorationList () {
      const url = '/xytsz/specialDecoration/page'
      this.dataListLoading = false
      this.$http.get(
        url,
        {
          params: {
            order: this.order,
            orderField: this.orderField,
            page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
            limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
            typeId: this.dataForm.typeId
          }
        }
      ).then(({ data: res }) => {
        this.dataListLoading = false
        console.log(res)
        if (res.code !== 0) {
          this.medalList = []
          this.total = 0
          return this.$message.error(res.msg)
        }
        this.medalList = this.mixinViewModuleOptions.getDataListIsPage ? res.data.list : res.data
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? res.data.total : 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    handleClick (tab, event) {
      this.dataForm.typeId = tab.name
      console.log(tab, event)
      console.log(this.dataForm.typeId)
      this.getDecorationList()
    },
    addHandle (type, index) {
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.decorationAddOrUpdate[index].dataForm.id = ''
        this.$refs.decorationAddOrUpdate[index].dataForm.typeId = type.id
        this.$refs.decorationAddOrUpdate[index].dataForm.typeName = type.typeName
        this.$refs.decorationAddOrUpdate[index].dataForm.decorationLevel = type.typeLevel
        this.$refs.decorationAddOrUpdate[index].init()
      })
    },
    updateHandle (id, index) {
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.decorationAddOrUpdate[index].dataForm.id = id
        this.$refs.decorationAddOrUpdate[index].init()
      })
    },
    deleteById (id) {
      this.$confirm(this.$t('prompt.info', { handle: this.$t('delete') }), '删除奖章后会影响正在进行的争章任务，是否确认删除？', {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http.get('xytsz/specialDecoration/deleteById/' + id).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.getDecorationList()
          this.$notify({
            type: 'info',
            duration: '750',
            message: '奖章删除成功'
          })
        })
      })
    },
    getTypeList () {
      this.$http.get('xytsz/specialDecorationType/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data.length > 0) {
          this.activeName = res.data[0].id
          this.dataForm.typeId = res.data[0].id
        }
        console.log(this.activeName)
        this.typeList = res.data
        this.getDecorationList()
      })
    }
  },
  watch: {
  },
  components: {
    AddOrUpdate,
    DecorationAddOrUpdate
  }
}
</script>
